const getDominantCategory = (facets) => {
  const dominantCategory = facets
    ?.find(({ key }) => key === 'RelevantCategories')
    ?.categories.find(({ dominant }) => dominant);

  return dominantCategory;
};

export default getDominantCategory;
